import React from "react";
import { useHistory } from "react-router-dom";
import { useTranslation } from "../../i18n/TranslationProvider";

import Sallie from "../UIComponents/Sallie";
import SubmitButton from "../UIComponents/SubmitButton";
import futureView from "../../images/FutureView2.png";

const Register = () => {
  const history = useHistory();
  const handleClick = () => {
    history.push("/BasicInfo");
  };

  const { t } = useTranslation();

  return (
    <>
      <div className="flex flex-col md:flex-row gap-8 mt-2 items-center">
        <div className="flex flex-col md:w-1/2">
          <Sallie text={t("register.sallie")} variant="wave" />
          <p>{t("register.part_one")}</p>
          <p>{t("register.part_two")}</p>
          <h6>{t("register.header")}</h6>
          <p>{t("register.watch_videos")}</p>
        </div>
        <div className="flex flex-col md:w-1/2 items-center">
          <div className="w-full h-[300px] overflow-hidden !border border-cyan-700 rounded mb-2">
            <img
              className="w-full h-full object-cover object-top"
              src={futureView}
              alt="Preview of the future dashboard"
              loading="lazy"
            />
          </div>
          <h6 className="text-center">{t("register.future_dashboard")}</h6>
        </div>
      </div>
      <div className="grid md:grid-cols-3 gap-4 my-4">
        <div className="flex flex-col items-center">
          <h6>{t("register.introduction_video")}</h6>
          <iframe
            className="w-full h-48 rounded"
            src="https://www.youtube.com/embed/J8ZTtsMRCvg"
            title={t("register.introduction_video")}
            aria-label={t("register.introduction_video")}
            allowFullScreen
            loading="lazy"
            referrerPolicy="strict-origin-when-cross-origin"
          />
        </div>
        <div className="flex flex-col items-center">
          <h6>{t("register.for_patients")}</h6>
          <iframe
            className="w-full h-48 rounded"
            src="https://www.youtube.com/embed/_HrjL5xB1nM"
            title={t("register.for_patients")}
            aria-label={t("register.for_patients")}
            allowFullScreen
            loading="lazy"
            referrerPolicy="strict-origin-when-cross-origin"
          />
        </div>
        <div className="flex flex-col items-center">
          <h6>{t("register.for_therapists")}</h6>
          <iframe
            className="w-full h-48 rounded"
            src="https://www.youtube.com/embed/xfeCmiZf_No"
            title={t("register.for_therapists")}
            aria-label={t("register.for_therapists")}
            allowFullScreen
            loading="lazy"
            referrerPolicy="strict-origin-when-cross-origin"
          />
        </div>
      </div>
      <a href="/signIn" className="text-teal-500 hover:text-teal-700">
        {t("register.sign_in")}
      </a>
      <SubmitButton
        type="button"
        onClick={handleClick}
        aria-label={`${t("register.start")} - Navigate to basic information form`}
      >
        {t("register.start")} &gt;
      </SubmitButton>
    </>
  );
};

export default Register;